import { SelectorItem } from "./SelectorItem";

export class ImageItem extends SelectorItem {
}
